/* ============================================================
   providerCatalogApi — PF-5 (TASK-e15bdfab): browse fetch for
   GET /api/v1/catalog/providers extended with the «влезет X×Y×Z»
   min-build-volume filter params.

   Standalone module on purpose (PF-4 precedent): the shared
   api/client.ts is mid-change by the concurrent PF-3 run
   (uncommitted catalog picker work); this card keeps its
   footprint out of that file. Same conventions as client.ts:
   Bearer when a session exists, ApiResult envelope unwrapping,
   readable ru error messages.
   ============================================================ */

import { getAccessToken } from '../auth/tokenStore';
import type { ApiResult } from '../types';
import type { ProviderCatalogBrowseResult } from '../types/provider';

const BASE_URL = `${import.meta.env.VITE_API_BASE ?? ''}/api/v1`;

export interface ProviderCatalogFilterParams {
  q?: string;
  city?: string;
  technology?: string;
  verified?: boolean;
  minBuildX?: number;
  minBuildY?: number;
  minBuildZ?: number;
  offset?: number;
  limit?: number;
}

export async function browseProviderCatalog(
  params: ProviderCatalogFilterParams = {},
): Promise<ProviderCatalogBrowseResult> {
  const qs = new URLSearchParams();
  const q = params.q?.trim();
  if (q) qs.set('q', q);
  if (params.city?.trim()) qs.set('city', params.city.trim());
  if (params.technology?.trim()) qs.set('technology', params.technology.trim());
  if (params.verified) qs.set('verified', 'true');
  if (params.minBuildX !== undefined) qs.set('minBuildX', String(params.minBuildX));
  if (params.minBuildY !== undefined) qs.set('minBuildY', String(params.minBuildY));
  if (params.minBuildZ !== undefined) qs.set('minBuildZ', String(params.minBuildZ));
  if (params.offset && params.offset > 0) qs.set('offset', String(params.offset));
  if (params.limit) qs.set('limit', String(params.limit));
  const suffix = qs.size > 0 ? `?${qs.toString()}` : '';

  const headers: Record<string, string> = {};
  const token = getAccessToken();
  if (token) headers.Authorization = `Bearer ${token}`;

  const res = await fetch(`${BASE_URL}/catalog/providers${suffix}`, { headers });

  const text = await res.text();
  let body: unknown = null;
  if (text.length > 0) {
    try {
      body = JSON.parse(text);
    } catch {
      // Non-JSON body — handled below.
    }
  }

  if (body && typeof body === 'object' && 'isSuccess' in body) {
    const result = body as ApiResult<ProviderCatalogBrowseResult>;
    if (result.isSuccess && result.value) return result.value;
    throw new Error(result.error ?? 'Не удалось загрузить исполнителей');
  }

  throw new Error(`Сервер вернул ошибку (HTTP ${res.status})`);
}
